export enum TagTypes {
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
  CODE = 'code',
  ADD_NEW = 'addNew',
}
